// Utility to determine the correct rate for a product order
export function setRate(
  { AACost, USDRetail, KRWRetail },
  currency,
  company,
  billingCountry
) {
  console.log('[setRate] 함수 호출:', {
    AACost,
    USDRetail,
    KRWRetail,
    currency,
    company,
    billingCountry,
  });

  let result;

  if (company && company.trim() === 'Aurender America Inc.') {
    // AA로 로그인한 경우
    if (
      billingCountry &&
      billingCountry.trim().includes('United States') &&
      AACost
    ) {
      // Billing Country가 United States인 경우
      result = AACost;
      return result;
    } else {
      // Billing Country가 United States가 아닌 경우
      result = USDRetail;
      return result;
    }
  }
  if (currency && currency.trim() === 'USD') {
    result = USDRetail;
    return result;
  } else if (currency && currency.trim() === 'KRW') {
    result = KRWRetail;
    return result;
  }
  result = USDRetail;
  return result;
}

// 한 라인에 적용할 단가를 구한다.
// 주문에 저장된 단가(productOrder.rate)가 있으면 그것을 쓴다. 상품 정가는 연 1회
// 개정되므로, 저장된 주문은 할인율이 바뀌어 금액을 다시 계산하더라도 견적 당시
// 단가를 유지해야 한다. 저장된 단가가 없으면(Rate 컬럼 도입 이전 주문, 새로 추가한
// 항목) 기존처럼 현재 정가로 계산한다.
export function resolveRate(productOrder, currency, company, billingCountry) {
  const stored = productOrder.rate;
  if (
    stored !== null &&
    stored !== undefined &&
    !isNaN(stored) &&
    Number(stored) !== 0
  ) {
    return Number(stored);
  }
  return setRate(
    {
      AACost: productOrder.product.AACost,
      USDRetail: productOrder.product.USDRetail,
      KRWRetail: productOrder.product.KRWRetail,
    },
    currency,
    company,
    billingCountry
  );
}

// 한 라인의 Amount를 구한다.
// SalesOrder에서 불러온 저장 금액(productOrder.amount)이 유효하면 그 값을 "그대로" 보존한다
// (= retail 단가가 나중에 바뀌어도 SalesOrder 작성 당시 금액 유지).
// 저장 금액이 없을 때(신규 추가 / 수량·할인 변경으로 amount가 null이 된 경우)에만
// setRate 기반으로 재계산한다. 화면 표시와 저장이 항상 같은 값을 쓰도록 모든 호출부에서 공유한다.
export function computeLineAmount(
  productOrder,
  currency,
  company,
  billingCountry
) {
  const stored = productOrder.amount;
  if (stored !== null && stored !== undefined && !isNaN(stored)) {
    return Number(stored);
  }

  const cur = currency ? currency.trim() : 'USD';
  const rate = resolveRate(productOrder, cur, company, billingCountry);
  const raw =
    Number(rate) *
    Number(productOrder.quantity) *
    ((100 - Number(productOrder.discount)) / 100);
  if (isNaN(raw)) return 0;
  return Number(raw.toFixed(cur === 'KRW' ? 0 : 2));
}
